// Local mirror of the `recordUserEvent` contract from
// `@hssoft/console-hssoft-com-service-mono-types`. The mutation lives on the centralized
// console GraphQL endpoint, not the wawi-service schema, so these types cannot come from the
// client's own codegen and are kept minimal and hand-written here.

/** Application identifier sent with every recorded event from this app. */
export const WAWIASSIST_APP_ID = 'wawiassist.hssoft.com';

/** The kind of event being recorded. */
export type UserEventType = 'ACTION' | 'LOGIN' | 'LOGOUT';

export interface RecordUserEventInput {
  /** Identifier of the application the event occurred in. */
  appId: string;
  /** The kind of event being recorded. */
  type: UserEventType;
  /** App version of the client at the time of the event (optional, for diagnostics). */
  appVersion?: string;
  /** Specific action identifier, typically set when `type` is ACTION (optional). */
  actionType?: string;
  /** Arbitrary event-specific data (optional). */
  metadata?: Record<string, unknown>;
}
